import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const whoIsOnCallRoute: InvariantJiraRoute = {
	name: 'eoc-who-is-on-call',
	path: '/jira/ops/who-is-on-call',
	exact: true,
};
